export default __webpack_public_path__ + "static/media/c001-E-commerce-1.51c65f7b.jpg";